import React, { useState } from "react";

import { Modal, Box, IconButton, Typography, Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Colors from "assets/Style/Colors"
import "./style.css";
import { Icons } from "assets";
import { useNavigate } from "react-router-dom";
import ShippingServices from "services/Shipping";
import { ErrorToaster } from "components/Toaster";

function SocialLinks() {
  const iconBtn = {
    borderRadius: 0,
    width: "50px",
    height: "70px",
    transition: "0.3s ease-in-out",
  };
  const [openTrackModal, setOpenTrackModal] = useState(false);
  const [selected, setSelected] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [trackingData, setTrackingData] = useState(null);
  const navigate = useNavigate();

  const handleTrack = async () => {
    if (!searchText || searchText.trim() === "") {
      ErrorToaster("Please enter VIN or Container #");
      return;
    }

    setLoading(true);
    setTrackingData(null);

    try {
      const params = { search: searchText };

      // if (selected === 1) {
      //   // Import API
      //   const { data } = await ShippingServices.getShippingTracking(params);
      //   setTrackingData(data);
      // } else {
        // Export API
        const { data } = await ShippingServices.getExportShippingTracking(params);
        setTrackingData(data);
      // }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenTrackModal(false);
    setSearchText("");
    setTrackingData(null);
    setSelected(1);
  };

  return (
    
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        right: 0,
        top: "10%",
        zIndex: 99,
      }}
    >
      <nav className="social">
        <ul>
          <li>
            <Box
              onClick={() => setOpenTrackModal(true)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                cursor: "pointer",
              }}
            >
              <img
                src={Icons.Track}
                width={40}
                height={40}
                style={{ borderRadius: 50 }}
              />
              <span>Track</span>
            </Box>
          </li>

          <li>
            <a
              style={{ alignItems: "center", display: "flex", gap: 5 }}
              href="https://twitter.com/GWWS_LLC"
              target={"_blank"} rel="noopener noreferrer" 
            >
              <img
                src={Icons.twitter}
                width={40}
                height={40}
                style={{ borderRadius: 50 }}
              />{" "}
              Twitter
            </a>
          </li>
          <li>
            <a
              style={{ alignItems: "center", display: "flex", gap: 5 }}
              href="https://www.linkedin.com/company/galaxyworldwideshipping"
              target={"_blank"} rel="noopener noreferrer" 
            >
              <img
                src={Icons.linkedIn}
                width={40}
                height={40}
                style={{ borderRadius: 50 }}
              />{" "}
              Linkedin
            </a>
          </li>
          <li>
            <a
              style={{ alignItems: "center", display: "flex", gap: 5 }}
              href="https://www.facebook.com/GalaxyWorldWideShipping"
              target={"_blank"}  rel="noopener noreferrer" 
            >
              <img
                src={Icons.fbIcon}
                width={40}
                height={40}
                style={{ borderRadius: 50 }}
              />{" "}
              Facebook
            </a>
          </li>
          <li>
            <a
              style={{ alignItems: "center", display: "flex", gap: 5 }}
              href="https://www.instagram.com/GalaxyWorldWideshippingllc"
              target={"_blank"}  rel="noopener noreferrer" 
            >
              <img
                src={Icons.insta}
                width={40}
                height={40}
                style={{ borderRadius: 50 }}
              />{" "}
              Instagram
            </a>
          </li>
        </ul>
      </nav>

      <Modal open={openTrackModal} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            height: { xs: "92%", sm: trackingData ? "auto" : 380 },
            width: { xs: "92%", sm: 560 },
            bgcolor: "white",
            borderRadius: 4,
            p: 6,
            outline: "none",
            overflowY: "auto",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "#000",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography fontSize={24} fontWeight={700} mb={0.5}>
            Track Your Shipment
          </Typography>
          <Typography fontSize={16} color="#262626" mb={3}>
            Enter VIN or Container number to track your shipment
          </Typography>

          {/* Import / Export Toggle */}
          <Box
            sx={{
              display: "inline-flex",
              borderRadius: 30,
              backgroundColor: "#F5F5F7",
              border: "1px solid #787878",
              overflow: "hidden",
              mb: 3,
            }}
          >
            <Box
              onClick={() => {
                setSelected(1);
                setTrackingData(null);
              }}
              sx={{
                px: 4,
                py: 2,
                borderRadius: 30,
                cursor: "pointer",
                fontWeight: 600,
                bgcolor: selected === 1 ? "#002878" : "transparent",
                color: selected === 1 ? "white" : "#000",
              }}
            >
              Import
            </Box>

            <Box
              onClick={() => {
                setSelected(2);
                setTrackingData(null);
              }}
              sx={{
                px: 4,
                py: 2,
                borderRadius: 30,
                cursor: "pointer",
                fontWeight: 600,
                bgcolor: selected === 2 ? "#002878" : "transparent",
                color: selected === 2 ? "white" : "#000",
              }}
            >
              Export
            </Box>
          </Box>

          {/* Search Field */}
          <Box
            sx={{
              display: "flex",
              border: "1px solid #353535",
              borderRadius: "13px",
              overflow: "hidden",
              mb: 2,
            }}
          >
            <TextField
              placeholder="Search via Vin/Container"
              variant="standard"
              fullWidth
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleTrack();
              }}
              InputProps={{ disableUnderline: true }}
              sx={{
                px: 2,
                py: 1.2,
              }}
            />

            <Button
              onClick={handleTrack}
              disabled={loading}
              sx={{
                minWidth: 40,
                bgcolor: Colors.landingPrimary,
                color: "white",
                borderRadius: 0,
                "&:hover": { bgcolor: Colors.landingPrimary },
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? "..." : (
                <img
                  src={Icons.Track}
                  width={40}
                  height={40}
                  style={{ borderRadius: 50 }}
                />
              )}
            </Button>
          </Box>

          {/* Tracking Result */}
          {trackingData && (
            <Box sx={{ mt: 3, p: 2, bgcolor: "#F5F5F7", borderRadius: 2 }}>
              <Typography fontWeight={700} fontSize={18} mb={1}>
                {trackingData?.details?.make} {trackingData?.details?.model}
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Typography fontWeight={600} fontSize={14}>VIN:</Typography>
                  <Typography fontSize={14} color="#555">{trackingData?.details?.vin || "N/A"}</Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Typography fontWeight={600} fontSize={14}>LOT:</Typography>
                  <Typography fontSize={14} color="#555">{trackingData?.details?.lot_number || "N/A"}</Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Typography fontWeight={600} fontSize={14}>Status:</Typography>
                  <Typography fontSize={14} color={Colors.landingPrimary} fontWeight={600}>
                    {selected === 1 ? "Import" : "Export"} Shipment
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/* Help */}
          <Typography fontSize={14} fontWeight={400} mt={2}>
            Need help?{" "}
            <span
              style={{ color: Colors.landingPrimary, cursor: "pointer", fontWeight: 500 }}
              onClick={() => navigate("/contact")}
            >
              Contact Us
            </span>
          </Typography>
        </Box>
      </Modal>

    </Box>
  );
}

export default SocialLinks;